import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import Clock from './Clock';
import { getPreview } from '../api';
import QuestionChoice from './QuestionChoice';
import QuestionRecord from './QuestionRecord';


const PreviewQuestion = () => {
  const params = useParams();
  const [question, setQuestion] = useState(null);

  useEffect(
    () => {
      async function fetch() {
        toast.info('Loading question...', {autoClose: 1500});
        try {
          const response = await getPreview(params.question);
          // The API answers an unresolvable eid with a soft 200 `{status: 'notfound'}`,
          // which `api.js` does not throw on — without this the page just stays blank.
          if (response.status !== 'ok') {
            toast.error('Question not found.');
            return;
          }
          setQuestion(response.question);
        } catch (error) {
          toast.error('Error loading question.');
          console.log(error);
        }
      }
      fetch();
      return () => {};
    },
    [params],
  );

  const handleAnswered = () => {};
  const handleTimeout = () => {};

  return (
    <>
      {question && (
        <>
          <Clock started={null} stopped={false} limit={question.timeLimit} onTimeout={handleTimeout} />
          {question.type === 'CHOICE' && (<QuestionChoice question={question} timeout={false} stopped={false} onAnswered={handleAnswered} />)}
          {question.type === 'RECORD' && (<QuestionRecord question={question} timeout={false} stopped={false} onAnswered={handleAnswered} />)}
        </>
      )}
    </>
  );
};

export default PreviewQuestion;
